import React, { FC } from 'react';
import { FormatChangeProjectFormProps } from './FormatChangeProjectFormProps';
import useTranslation from '../../../hooks/useTranslation';
import ProjectDetailsFields from '../ProjectDetailsFields';
import ProjectConfidentialButton from '../ProjectConfidentialButton';
import Divider from '../../Divider';
import ProjectInformationFields from '../ProjectInformationFields';
import ProjectDatesFields from '../ProjectDatesFields';
import Text from '@ingka/text';
import PartOfCrpForm from '../PartOfCrpForm';
const FormatChangeProjectForm: FC<FormatChangeProjectFormProps> = ({
  projectList,
  isConfidentialAllowed,
  isep,
}) => {
  const t = useTranslation();
  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.projectDetails')}
      </Text>
      <ProjectDetailsFields
        projectList={projectList}
        unifier={isep}
        type={'Format Change'}
      />
      {isConfidentialAllowed && <ProjectConfidentialButton />}
      <Divider />
      <PartOfCrpForm />
      <Divider />
      <ProjectInformationFields />
      <Divider />
      <ProjectDatesFields
        openingDate
        initialDates
        projectClosingDate
        isep={isep}
      />
    </>
  );
};

export default FormatChangeProjectForm;
